type AttachmentAction = 'download' | 'open_preview'

export interface AttachmentHandlerResult {
  action: AttachmentAction
}

const PREVIEW_CONTENT_TYPES = new Set(['application/pdf', 'text/plain', 'image/jpeg', 'image/png'])

const PREVIEW_EXTENSIONS = new Set(['.pdf', '.txt', '.jpg', '.jpeg', '.png'])

export function classifyAttachment(contentType: string | undefined, filename: string): AttachmentHandlerResult {
  // Primary: content-type (strip charset/parameters)
  if (contentType) {
    const baseType = contentType.toLowerCase().split(';')[0].trim()
    if (PREVIEW_CONTENT_TYPES.has(baseType)) {
      return { action: 'open_preview' }
    }
    // Content-type is set but not previewable - trust it and download
    return { action: 'download' }
  }

  // Fallback: file extension (only when content-type is missing)
  const ext = filename.toLowerCase().match(/\.[^.]+$/)?.[0]
  if (ext && PREVIEW_EXTENSIONS.has(ext)) {
    return { action: 'open_preview' }
  }

  return { action: 'download' }
}
